var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Kingfisher",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "INSURANCE-//-Submit-policy-Copy",
    transform: "translate(-304.000000, -366.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(304.000000, 366.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D8D7D6",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 12.000000) rotate(45.000000) translate(-12.000000, -12.000000) translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#000000",
    x: 3.18323146e-13,
    y: 6.3,
    width: 14,
    height: 1.07692308,
    rx: 0.538461538
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.56,6.3 L12.9015385,6.3 C13.2108179,6.3 13.4615385,6.55072054 13.4615385,6.86 C13.4615385,7.16927946 13.2108179,7.42 12.9015385,7.42 L0.56,7.42 C0.25072054,7.42 -3.37148741e-12,7.16927946 -3.37152528e-12,6.86 C-3.37156316e-12,6.55072054 0.25072054,6.3 0.56,6.3 Z",
    id: "Rectangle-2-Copy",
    fill: "#000000",
    transform: "translate(6.730769, 6.860000) rotate(90.000000) translate(-6.730769, -6.860000) "
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGray);
export default __webpack_public_path__ + "static/media/close-gray.2e7c4464.svg";
export { ForwardRef as ReactComponent };